module Bookhus.Widgets {
    class LocalizedValues {
        private translations: any = {
            PropertyList: {
                da: "Emneliste",
                "en-GB": "Propertylist",
                de: "Objektliste",
                sv: "Fastighetslista",
                no: "Eiendomsliste"
            }
        }

        get(name: string, lang?: string): string {

            if (this.translations[name] == undefined || this.translations[name] == null) {
                return "Oversættelse findes ikke";
            }

            var langCode = $.datepicker.regional.bookhuscurrent as string;
            if (lang != undefined && lang != null) {
                langCode = lang;
            }

            var value = this.translations[name][langCode] || this.translations[name]["da"];
            if (value == undefined || value == "") {
                return "Oversættelse findes ikke";
            }
            return value;
        }
    }

    export class PropertyList {
        container: JQuery;
        translations: LocalizedValues;

        constructor(container: JQuery) {
            this.container = container;
            this.translations = new LocalizedValues();

            this.createLabel().appendTo(this.container);
            this.createDropdown().appendTo(this.container);
            this.initEvents();
        }

        

        private createLabel(): JQuery {
            return $(`<label id="emneListeLabel" class="mb-1">${this.translations.get("PropertyList")}</label>`);
        }

        private createDropdown(): JQuery {
            return $(`<div class="dropdown">
                <input id="emnelistInput" type="text" name="Text" class="form-control" data-toggle="dropdown" data-flip="false" aria-labelledby="emneListeLabel"/>
                <div class="dropdown-menu w-100">
                </div>
            </div>`);
        }

        private initEvents(): void {
            $(window).on('click', () => {
                $('.emnelistBody', this.container).css('display', 'none');
            });

            var search = (text: string) => {
                $.ajax({
                    url: '/api/GetCatalogEmneList',
                    cache: false,
                    data: {
                        text: text
                    }
                }).done((items: IItem[]) => {
                    this.renderItemList(items);
                });
            }

            $('#emnelistInput', this.container).on('keyup', this.debounce((e) => {
                var $input = $(e.target);
                search($input.val());
            }, 200, false));

            $('#emnelistInput', this.container).on('click', function (e) {
                var $input = $(e.target);
                search($input.val());
                return false;
            });
        }

        private renderItemList(items: IItem[]): void {
            var content = "";
            for (var i = 0; i < items.length; i++) {
                var current = items[i];
                if (current.isExternal) {
                    continue;
                }
                
                content +=
                    `<li class="list-group-item d-flex justify-content-between align-items-center">
                        <p class="mb-0">${current.title}</p>
                        <a class="btn btn-success btn-sm" href="${current.bookLink}">Book</a>
                    </li>`;

            }
            if (!content || content.length == 0) {
                content +=
                    `<li class="list-group-item d-flex justify-content-between align-items-center">
                        <p class="mb-0">Ingen emner fundet</p>
                    </li>`;
            }

            var html = `
                <ul class="list-group list-group-flush">
                    ${content}
                </ul>`;

            $('#emnelistInput ~ .dropdown-menu', this.container).html('');
            $('#emnelistInput ~ .dropdown-menu', this.container).html(html);
            $('#emnelistInput', this.container).dropdown('show');
        }

        private debounce(func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }
    }
}

//const pluginName = 'bookhus_property_list';
$.fn.propertyList = function () {
    var propertyList = new Bookhus.Widgets.PropertyList(this);
    return this;
}